<!-- Overlay backdrop -->
<div *ngIf="!inlineMode"
     class="comments-overlay" 
     [@overlay]="visible" 
     (click)="close()">
</div>

<!-- Sidebar panel -->
<div
  class="comments-panel"
  [class.inline-mode]="inlineMode"
  [@slidePanel]="inlineMode ? false : visible"
>
  <!-- Panel header -->
  <div class="panel-header">
    <div class="header-content">
      <i class="pi pi-comment"></i>
      <h3>Comments</h3>
      <span class="comment-count">{{ getCommentCountText() }}</span>
    </div>
    <button
      *ngIf="!inlineMode"
      pButton 
      type="button"
      icon="pi pi-times" 
      class="p-button-text p-button-rounded"
      (click)="close()"
      pTooltip="Close"
      tooltipPosition="left">
    </button>
  </div>

  <!-- Panel body -->
  <div class="panel-body" [class.work-queue]="workQueue"
  [class.normal-queue]="!workQueue" #panelBody>
    <!-- Loading state -->
    <div class="loading-container" *ngIf="loading">
      <p-progressSpinner 
        [style]="{ width: '50px', height: '50px' }" 
        strokeWidth="4">
      </p-progressSpinner>
      <p>Loading comments...</p>
    </div>

    <!-- Comments list -->
    <div class="comments-list" *ngIf="!loading">
      <!-- Empty state -->
      <div class="empty-state" *ngIf="comments.length === 0">
        <i class="pi pi-comments"></i>
        <p>No comments yet</p>
        <span>Be the first to comment!</span>
      </div>

      <!-- Threaded comments (parent → nested replies) -->
      <ng-container
        *ngTemplateOutlet="commentThread; context: { nodes: threadedComments, parent: null }">
      </ng-container>
    </div>
  </div>

  <!-- Reply form (shown when replying) -->
  <div class="reply-form" *ngIf="replyToComment">
    <div class="reply-header">
      <span>Replying to <strong>{{ getReplyTargetName() }}</strong></span>
      <button 
        pButton 
        type="button"
        icon="pi pi-times" 
        class="p-button-text p-button-sm"
        (click)="cancelReply()">
      </button>
    </div>
    
    <div class="composer-body">
      <div class="composer-integrated" [class.has-attachments]="replyAttachments.length">
        <p-editor [(ngModel)]="replyText" [modules]="editorModules" [style]="{ height: '160px' }" placeholder="Write your reply..."
          (onTextChange)="onEditorTextChange($event, 'reply')">

          <ng-template pTemplate="header">

            <span class="ql-formats">
              <select class="ql-header">
                <option value="1"></option>
                <option value="2"></option>
                <option selected></option>
              </select>
            </span>

            <span class="ql-formats">
              <button type="button" class="ql-bold"></button>
              <button type="button" class="ql-italic"></button>
              <button type="button" class="ql-underline"></button>
            </span>

            <span class="ql-formats">
              <button type="button" class="ql-list" value="ordered"></button>
              <button type="button" class="ql-list" value="bullet"></button>
            </span>
            
            <span class="ql-formats">
              <button type="button" class="custom-attachment-btn" (click)="replyFileInput.click()">
                <i class="pi pi-paperclip"></i>
              </button>
            </span>

          </ng-template>

        </p-editor>

        <input #replyFileInput type="file" multiple hidden (change)="onReplyFilesSelected($event)" />

        <div class="composer-attachments composer-attachments-strip" *ngIf="replyAttachments.length">
          <div class="composer-attachment-item" *ngFor="let att of replyAttachments; let i = index">
            <div class="composer-attachment-thumb">
              <img *ngIf="isImageFile(att.file)" [src]="att.previewUrl" [alt]="att.file.name" class="thumb-image" />
              <div *ngIf="!isImageFile(att.file)" class="thumb-doc" [attr.aria-label]="att.file.name">
                <i class="pi pi-file"></i>
                <span class="thumb-ext">{{ getFileExtension(att.file.name) }}</span>
              </div>
              <div class="thumb-overlay">
                <button
                  type="button"
                  pButton
                  icon="pi pi-eye"
                  class="p-button-rounded p-button-text thumb-action-btn"
                  (click)="openAttachmentPreview(att)"
                  pTooltip="Preview"
                  tooltipPosition="top">
                </button>
                <button
                  type="button"
                  pButton
                  icon="pi pi-trash"
                  class="p-button-rounded p-button-text thumb-action-btn thumb-remove-btn"
                  (click)="removeReplyAttachment(i)"
                  pTooltip="Remove"
                  tooltipPosition="top">
                </button>
              </div>
            </div>
            <span
              class="composer-attachment-name"
              [pTooltip]="att.file.name"
              tooltipPosition="bottom">{{ att.file.name }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="composer-body">
      <app-mention-input
        #replyInput
        [(value)]="replyText"
        [rows]="3"
        [autoResize]="true"
        placeholder="Write your reply...">
      </app-mention-input>

      <div class="attachment-input-row">
        <input #replyFileInput type="file" multiple style="display: none;" (change)="onReplyFilesSelected($event)" />
        <button pButton type="button" icon="pi pi-paperclip" class="p-button-text" (click)="replyFileInput.click()">
        </button>
        <small *ngIf="replyFiles.length">{{ replyFiles.length }} file(s) selected</small>
      </div>

      <div class="selected-files" *ngIf="replyFiles.length">
        <div class="selected-file-item" *ngFor="let file of replyFiles; let i = index">
          <span>{{ file.name }}</span>
          <button pButton type="button" icon="pi pi-times" class="p-button-text p-button-sm" (click)="removeReplyFile(i)">
          </button>
        </div>
      </div>
    </div> -->

    <div class="form-actions">
      <div class="internal-toggle">
        <p-checkbox
          [(ngModel)]="isInternal"
          [binary]="true"
          inputId="replyInternal"
          label="Internal only">
        </p-checkbox>
      </div>
      
      <div class="action-buttons submit-actions">
        <button 
          pButton 
          type="button"
          label="Cancel" 
          class="p-button-text cancel-btn"
          (click)="cancelReply()"
          [disabled]="isReplySubmitting">
        </button>
        <button 
          pButton 
          type="button"
          label="Reply"
          class="p-button-rounded comment-send-label"
          (click)="submitReply()"
          [disabled]="isReplySubmitting || !hasReplyEditorText()">
        </button>
      </div>
    </div>
  </div>

  <!-- New comment form (bottom) -->
  <div class="new-comment-form" *ngIf="!replyToComment">
    <div class="form-header">
      <h4>Add Comment</h4>
    </div>

    <div class="composer-body"  [style]="{
    height: workQueue ? '150px' : '180px'
  }">
      <div class="composer-integrated" [class.has-attachments]="newCommentAttachments.length">
        <p-editor [(ngModel)]="newCommentText" [modules]="editorModules" [style]="{ height: '180px' }" placeholder="Write a comment..."
          (onTextChange)="onEditorTextChange($event, 'comment')">

          <ng-template pTemplate="header">

            <span class="ql-formats">
              <select class="ql-header">
                <option value="1"></option>
                <option value="2"></option>
                <option selected></option>
              </select>
            </span>

            <span class="ql-formats">
              <button type="button" class="ql-bold"></button>
              <button type="button" class="ql-italic"></button>
              <button type="button" class="ql-underline"></button>
            </span>

            <span class="ql-formats">
              <button type="button" class="ql-list" value="ordered"></button>
              <button type="button" class="ql-list" value="bullet"></button>
            </span>

            <!-- Attachment Button -->
            <span class="ql-formats">
              <button type="button" class="custom-attachment-btn" (click)="newCommentFileInput.click()">
                <i class="pi pi-paperclip" style="font-size: 13px; color: #494b4e"></i>
              </button>
            </span>

          </ng-template>

        </p-editor>

        <input #newCommentFileInput type="file" multiple hidden (change)="onNewCommentFilesSelected($event)" />

        <div class="composer-attachments composer-attachments-strip" *ngIf="newCommentAttachments.length">
          <div class="composer-attachment-item" *ngFor="let att of newCommentAttachments; let i = index">
            <div class="composer-attachment-thumb">
              <img *ngIf="isImageFile(att.file)" [src]="att.previewUrl" [alt]="att.file.name" class="thumb-image" />
              <div *ngIf="!isImageFile(att.file)" class="thumb-doc" [attr.aria-label]="att.file.name">
                <i class="pi pi-file"></i>
                <span class="thumb-ext">{{ getFileExtension(att.file.name) }}</span>
              </div>
              <div class="thumb-overlay">
                <button
                  type="button"
                  pButton
                  icon="pi pi-eye"
                  class="p-button-rounded p-button-text thumb-action-btn"
                  (click)="openAttachmentPreview(att)"
                  pTooltip="Preview"
                  tooltipPosition="top">
                </button>
                <button
                  type="button"
                  pButton
                  icon="pi pi-trash"
                  class="p-button-rounded p-button-text thumb-action-btn thumb-remove-btn"
                  (click)="removeNewCommentAttachment(i)"
                  pTooltip="Remove"
                  tooltipPosition="top">
                </button>
              </div>
            </div>
            <span
              class="composer-attachment-name"
              [pTooltip]="att.file.name"
              tooltipPosition="bottom">{{ att.file.name }}</span>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="composer-body">
      <app-mention-input
        #newCommentInput
        [(value)]="newCommentText"
        [rows]="3"
        [autoResize]="true"
        placeholder="Write a comment...">
      </app-mention-input>

      <div class="attachment-input-row">
        <input #newCommentFileInput type="file" multiple style="display: none;" (change)="onNewCommentFilesSelected($event)" />
        <button pButton type="button" icon="pi pi-paperclip" class="p-button-text" (click)="newCommentFileInput.click()">
        </button>
        <small *ngIf="newCommentFiles.length">{{ newCommentFiles.length }} file(s) selected</small>
      </div>

      <div class="selected-files" *ngIf="newCommentFiles.length">
        <div class="selected-file-item" *ngFor="let file of newCommentFiles; let i = index">
          <span>{{ file.name }}</span>
          <button pButton type="button" icon="pi pi-times" class="p-button-text p-button-sm" (click)="removeNewCommentFile(i)">
          </button>
        </div>
      </div>
    </div> -->

    <div class="form-actions">
      <div class="internal-toggle">
        <p-checkbox
          [(ngModel)]="isInternal"
          [binary]="true"
          inputId="commentInternal"
          label="Internal only">
        </p-checkbox>
      </div>

      <div class="action-buttons submit-actions">
        <button
          pButton
          type="button"
          label="Save"
          class="p-button-rounded comment-send-label"
          (click)="createComment()"
          [disabled]="isSubmitting || !hasNewCommentEditorText()">
        </button>
      </div>
    </div>
  </div>
</div>

<p-dialog
  header="Preview"
  [(visible)]="previewDialogVisible"
  [closable]="true"
  closeIcon="pi pi-times"
  closeAriaLabel="Close preview"
  [modal]="true"
  [dismissableMask]="true"
  appendTo="body"
  [style]="{ width: 'min(92vw, 720px)' }"
  [contentStyle]="{ overflow: 'auto', maxHeight: '80vh' }"
  (onHide)="onPreviewDialogHide()">
  <ng-container *ngIf="previewAttachment as pa">
    <img *ngIf="isImageFile(pa.file)" [src]="pa.previewUrl" [alt]="pa.file.name" class="attachment-preview-img" />
    <iframe
      *ngIf="isPdfFile(pa.file)"
      [title]="pa.file.name"
      [src]="previewPdfSrc()"
      class="attachment-preview-iframe"></iframe>
    <div *ngIf="!isImageFile(pa.file) && !isPdfFile(pa.file)" class="attachment-preview-fallback">
      <i class="pi pi-file attachment-preview-fallback-icon"></i>
      <p class="attachment-preview-name">{{ pa.file.name }}</p>
      <a
        pButton
        type="button"
        class="p-button-outlined p-button-sm"
        [href]="pa.previewUrl"
        target="_blank"
        rel="noopener noreferrer">
        <span>Open in new tab</span>
      </a>
    </div>
  </ng-container>
</p-dialog>

<ng-template #commentThread let-nodes="nodes" let-parent="parent">
  <div
    *ngFor="let node of nodes"
    class="comment-thread-node"
    [class.comment-thread-node--reply]="parent">
    <app-comment-item
      [comment]="node.comment"
      [parentComment]="parent"
      [currentUserId]="currentUserId"
      [isAdmin]="isAdmin"
      [attachmentTags]="attachmentTags"
      (replyClicked)="onReplyClicked($event)"
      (commentUpdated)="onCommentUpdated()"
      (commentDeleted)="onCommentDeleted($event)">
    </app-comment-item>
    <div class="comment-replies" *ngIf="node.replies.length">
      <ng-container
        *ngTemplateOutlet="commentThread; context: { nodes: node.replies, parent: node.comment }">
      </ng-container>
    </div>
  </div>
</ng-template>

<p-toast></p-toast>
